import { useContext, useState, useEffect } from 'react';

import { DownOutlined, UpOutlined } from '@ant-design/icons';
import Cookies from 'js-cookie';
import { useRouter } from 'next/router';

import { LayoutContext } from '@lcsc-ui/layouts/baseLayout/provider';
import Utils from '@lcsc-ui/utils/Utils';

export const BottomLink = ({ hideFooterOther = false }) => {
  const [friendWebsiteElIsShow, setFriendWebsiteElIsShow] = useState(false);
  const [memberWebsiteElIsShow, setMemberWebsiteElIsShow] = useState(false);

  const { resourceData, showMemberWebsite } = useContext(LayoutContext);
  const memberWebSiteList = resourceData?.commonConfigVO?.memberWebsite || [];
  const friendWebSiteList = resourceData?.commonConfigVO?.friendWebsite || [];
  const [jlcGroup_source, set_jlcGroup_source] = useState();
  const [saveCode, setSaveCode] = useState();
  const router = useRouter();

  const letter = [
    { idx: '其他', urlPage: '/ic/other.html' },
    { idx: 'A', urlPage: '/ic/A.html' },
    { idx: 'B', urlPage: '/ic/B.html' },
    { idx: 'C', urlPage: '/ic/C.html' },
    { idx: 'D', urlPage: '/ic/D.html' },
    { idx: 'E', urlPage: '/ic/E.html' },
    { idx: 'F', urlPage: '/ic/F.html' },
    { idx: 'G', urlPage: '/ic/G.html' },
    { idx: 'H', urlPage: '/ic/H.html' },
    { idx: 'I', urlPage: '/ic/I.html' },
    { idx: 'J', urlPage: '/ic/J.html' },
    { idx: 'K', urlPage: '/ic/K.html' },
    { idx: 'L', urlPage: '/ic/L.html' },
    { idx: 'M', urlPage: '/ic/M.html' },
    { idx: 'N', urlPage: '/ic/N.html' },
    { idx: 'O', urlPage: '/ic/O.html' },
    { idx: 'P', urlPage: '/ic/P.html' },
    { idx: 'Q', urlPage: '/ic/Q.html' },
    { idx: 'R', urlPage: '/ic/R.html' },
    { idx: 'S', urlPage: '/ic/S.html' },
    { idx: 'T', urlPage: '/ic/T.html' },
    { idx: 'U', urlPage: '/ic/U.html' },
    { idx: 'V', urlPage: '/ic/V.html' },
    { idx: 'W', urlPage: '/ic/W.html' },
    { idx: 'X', urlPage: '/ic/X.html' },
    { idx: 'Y', urlPage: '/ic/Y.html' },
    { idx: 'Z', urlPage: '/ic/Z.html' },
    { idx: '0', urlPage: '/ic/0.html' },
    { idx: '1', urlPage: '/ic/1.html' },
    { idx: '2', urlPage: '/ic/2.html' },
    { idx: '3', urlPage: '/ic/3.html' },
    { idx: '4', urlPage: '/ic/4.html' },
    { idx: '5', urlPage: '/ic/5.html' },
    { idx: '6', urlPage: '/ic/6.html' },
    { idx: '7', urlPage: '/ic/7.html' },
    { idx: '8', urlPage: '/ic/8.html' },
    { idx: '9', urlPage: '/ic/9.html' },
  ];

  useEffect(() => {
    set_jlcGroup_source(router?.query?.jlcGroup_source || Cookies.get('jlcGroup_source'));
  }, [router?.query?.jlcGroup_source]);

  useEffect(() => {
    setSaveCode(router?.query?.c || Cookies.get('cookies_save_operation_code_mark'));
  }, [router?.query?.c]);

  const toNewPage = (event, url) => {
    event.preventDefault();
    if (confirm('确认打开链接进入第三方网站吗？')) {
      window.open(url);
    }
    return false;
  };

  // 成员网站
  const memberWebsiteEl = memberWebSiteList
    .filter((item) => item.status === 'enable')
    .map((item, index) => (
      <li key={index} className="mb-[10px] mr-[30px] w-[9%] truncate hover:text-[#0095E7]">
        <a
          data-spm={index + 1}
          href={Utils.groupJumpUrl(item.url, jlcGroup_source, saveCode)}
          target="_blank"
          rel={item.url?.includes('/selection.html') ? '' : 'nofollow'}
          title={item.title || item.keyword}
          className={`${item.needBold === 'yes' ? 'text-bold' : ''} ${item.fontColor ? `text-[${item.fontColor}]` : ''}`}
        >
          {item.keyword}
        </a>
      </li>
    ));

  // 友情链接
  const friendWebsiteEl = friendWebSiteList.map((item, index) => (
    <li key={index} className="mb-[10px] mr-[30px] w-[9%] truncate hover:text-[#0095E7]">
      <a
        data-spm={index + 1}
        href={item.url}
        target="_blank"
        rel="nofollow"
        onClick={(e) => toNewPage(e, item.url)}
        title={item.title || item.keyword}
        className={`${item.needBold === 'yes' ? 'text-bold' : ''} ${item.fontColor ? `text-[${item.fontColor}]` : ''} `}
      >
        {item.keyword}
      </a>
    </li>
  ));

  // 字母索引
  const letterEl = letter.map((item, index) => (
    <li key={index} className="mr-[12px] hover:text-[#0095E7]">
      <a data-spm={index + 1} href={`${resourceData?.projectConfigVO?.lcscWwwUrl}${item.urlPage}`} target="_blank">
        {item.idx}
      </a>
    </li>
  ));

  return (
    <div className="1200px mx-auto">
      <>
        <div
          data-spm="cy"
          className={`relative flex ${hideFooterOther ? 'mb-0' : `${memberWebsiteElIsShow ? 'mb-[3px]' : 'mb-[16px]'}`}`}
        >
          <p className="w-[64px] text-[12px] font-bold text-[#333]">成员网站：</p>
          <ul
            className={`flex w-[1100px] flex-wrap items-center text-[12px] text-[#666] transition-all duration-500 ${memberWebsiteElIsShow ? 'h-auto' : 'h-[16px] overflow-hidden'}`}
          >
            {memberWebsiteEl}
          </ul>
          {memberWebSiteList.length > 8 && (
            <button
              className="hover:text-lcBlue absolute right-0 text-[#666]"
              onClick={() => setMemberWebsiteElIsShow(!memberWebsiteElIsShow)}
            >
              {memberWebsiteElIsShow ? '收起' : '展开'}
              {memberWebsiteElIsShow ? (
                <UpOutlined className="ml-[6px] h-[8px] w-[8px]" />
              ) : (
                <DownOutlined className="ml-[6px] h-[8px] w-[8px]" />
              )}
            </button>
          )}
        </div>
        {showMemberWebsite && (
          <div data-spm="yq" className={`relative flex ${friendWebsiteElIsShow ? 'mb-[3px]' : 'mb-[16px]'}`}>
            <p className="w-[64px] text-[12px] font-bold text-[#333]">友情链接：</p>
            <ul
              className={`flex w-[1100px] flex-wrap items-center text-[12px] text-[#666] transition-all duration-500 ${friendWebsiteElIsShow ? 'h-auto' : 'h-[16px] overflow-hidden'}`}
            >
              {friendWebsiteEl}
              <li className="mb-[13px] text-[#0095E7]">
                <a href={`${resourceData?.projectConfigVO?.lcscWwwUrl}/links.html`} target="_blank" rel="nofollow">
                  更多{'>>'}
                </a>
              </li>
            </ul>
            <button
              className="hover:text-lcBlue absolute right-0 text-[#666]"
              onClick={() => setFriendWebsiteElIsShow(!friendWebsiteElIsShow)}
            >
              {friendWebsiteElIsShow ? '收起' : '展开'}
              {friendWebsiteElIsShow ? (
                <UpOutlined className="ml-[6px] h-[8px] w-[8px]" />
              ) : (
                <DownOutlined className="ml-[6px] h-[8px] w-[8px]" />
              )}
            </button>
          </div>
        )}
      </>
      {!hideFooterOther && (
        <div data-spm="zm" className="flex">
          <p className="w-[64px] text-[12px] font-bold text-[#333]">字母索引：</p>
          <ul className="flex items-center text-[12px] text-[#666]">{letterEl}</ul>
        </div>
      )}
    </div>
  );
};
